import React from 'react'

// Local inline glyph, not from @fs/zion-icon: the package has no 9-dot
// "apps grid" (its closest are ControlGrid, nine outlined squares in a
// frame, and MenuMore, a vertical 3-dot kebab). The Home pill uses this
// launcher-style waffle instead of a house. Dot radius and 5/12/19 grid
// positions match MenuMore's dot scale so it sits in the same family.
// Candidate for promotion into the design system later.
export default function NineDotIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false">
      {[5, 12, 19].map((cy) => [5, 12, 19].map((cx) => <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="2" />))}
    </svg>
  )
}
